/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment, useMemo, useRef } from 'react';
import { DataGrid, } from '@mui/x-data-grid';
import {
    createTheme,
    ThemeProvider,
    styled,
    Box,
    Button,
    Stack,
    Paper,
    Divider,
    Grid
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import ToPrintPageAdditionalExammanagement from "../components/ToPrintPageAdditionalExammanagement";
/*------------------ External Function -----------*/
import { convertToEngDate } from "../components/functions/GlobalFunctions";

/*------------------ Redux -----------------------*/
import { useSelector, useDispatch } from 'react-redux';
import { fetchTestResultByDateTimeLabroom } from '../store/TestMgmtSlice';

/*----------------- theme ------------------------*/
const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: 'THSarabunNew',
            fontSize: 14
        }
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: 'THSarabunNew',
                },
            }
        },
    }

});

/*----------------------- Style ------------------*/
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    fontFamily: 'THSarabunNew',
    color: theme.palette.text.secondary
}));

/*--------------------- PageExamManagement ---------------------*/
function PageAdditionalExamManagement() {
    const location = useLocation();
    const [rows, setRows] = useState([]);

    /*----------------------------- Redux ----------------------------------*/
    const testresultlist = useSelector(state => state.testmgmtstate.testresultdtlbarr);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTestResultByDateTimeLabroom({
            resvcode: location.state.testresvcode,
            labroom: location.state.labroom,
            date: convertToEngDate(location.state.testdate),
            time: location.state.testtime.split(' - ')[0]
        }));
    }, [location.state]);

    //console.log('PageAdditionalExamManagement ---> testresultlist: ', testresultlist);
    useEffect(() => {
        setRows(testresultlist);
    }, [testresultlist])

    /*----------------------------- DataGrid Columns ------------------------*/
    const columns = [
        { field: "id", headerName: "ลำดับ", width: 100, align: 'center', headerAlign: 'center', },
        { field: 'resvcode', headerName: 'รหัสการจอง', width: 200, align: 'center', headerAlign: 'center', },
        { field: "idnumber", headerName: "เลขประจำตัว", width: 200, align: 'center', headerAlign: 'center', },
        { field: "name", headerName: "ยศ ชื่อ นามสกุล", width: 250, align: 'left', headerAlign: 'left', },
        { field: "type", headerName: "แบบ", width: 250, align: 'center', headerAlign: 'center', },
        { field: "form", headerName: "ฟอร์ม", width: 200, align: 'center', headerAlign: 'center', },
    ];

    /*-------------------------------------------------------------*/
    /*-------------------------- Return ---------------------------*/
    /*-------------------------------------------------------------*/
    return (
        <ThemeProvider theme={theme}>
            <Stack
                divider={<Divider flexItem />}
                spacing={1}
            >
                {/*-------------- Title -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                    }}>
                    รายการชื่อผู้เข้าสอบห้องสอบ {location.state.labroom.toUpperCase()}
                </Item>
                {/*-------------- Date & Time -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                    }}>
                    วันทดสอบ {location.state.testdate}&emsp;&emsp;เวลาทดสอบ {location.state.testtime}
                </Item>
                {/*-------------- Datagrid -----------------*/}
                <Item elevation={0}>
                    <Box sx={{ height: 400, width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                            localeText={{ noRowsLabel: "ไม่พบรายการการจัดการทดสอบ" }}
                            componentsProps={{
                                pagination: {
                                    labelRowsPerPage: "จำนวนแถวต่อหน้า",
                                    labelDisplayedRows: ({ from, to, count }) => {
                                        return `${from}–${to} ของ ${count !== -1 ? count : `มากกว่า ${to}`}`;
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold !important',
                                    //overflow: 'visible !important'
                                }
                            }}
                        />
                    </Box>
                </Item>
                {/*-------------- Backward Button -----------------*/}
                <Item
                    elevation={0}
                    sx={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Link to="/PageResvCodeListLabMgmt"
                                style={{ textDecoration: "none" }}
                                state={{
                                    'thdate': location.state.testdate,
                                    'engdate': convertToEngDate(location.state.testdate),
                                    'time': location.state.testtime,
                                    'labroom': location.state.labroom,
                                }}
                            >
                                <Button
                                    variant='contained'
                                    sx={{
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        width: 200, padding: 1, margin: 2
                                    }}
                                >
                                    ย้อนกลับ
                                </Button>
                            </Link>
                        </Grid>
                        {/*-------------- Page Print -----------------*/}
                        <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                            <ToPrintPageAdditionalExammanagement
                                toprint={{
                                    'thdate': location.state.testdate,
                                    'time': location.state.testtime,
                                    'labroom': location.state.labroom,
                                    'rows': rows
                                }}
                            />
                        </Grid>
                    </Grid>
                </Item>
            </Stack>
        </ThemeProvider >
    );
}

export default PageAdditionalExamManagement;